import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PassportProduct } from '@app/core/interfaces';
import { PurchasedProductInterface, RelationInterface, RelationDataService } from 'outshared-lib';
import { Observable } from 'rxjs';
import { PassportService } from './passport.service';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@Component({
    selector: 'ins-passport-container',
    template: `
        <ins-passport [relation]="relation$ | async" [passportProducts]="passportProducts$ | async"></ins-passport>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PassportContainer {
    public relation$: Observable<RelationInterface>;
    public passportProducts$: Observable<PassportProduct[]>;

    constructor(private passportService: PassportService, private relationDataService: RelationDataService) {
        this.relation$ = this.relationDataService.getRelation$();
        this.passportProducts$ = this.passportService.getPassportProducts$();
    }
}
